import _extends from "@babel/runtime/helpers/extends";
import { WixDesignSystemProvider } from '@wix/design-system';
import React, { useEffect, useMemo, useState } from 'react';
import { initBiLogger, reportInstallerInitiated } from './bi/bi';
import { v4 as uuidv4 } from 'uuid';
import { InstallerMainContextProvider } from './context/InstallerContext';
import { ModalsContextProvider } from './context/ModalsContext';
import { ErrorHandlerProvider } from './components/ErrorBoundary/ErrorHandlerProvider';
import { PanoramaContextProvider } from './context/PanoramaContext';
import { AppWrapper } from './components/App/AppWrapper';
import { useRenderControl } from './context/InstallerRenderControlContext';
import { getI18n } from './services/i18n';
import { I18nextProvider } from '@wix/wix-i18n-config';
import { NewWindowHandlersContextProvider } from './context/NewWindowHandlersContext';
import { AppInstallerPropsContext } from './AppInstallerPropsContext';
export const AppInstallerContent = _ref => {
  let {
    tenantId: initialTenantId,
    essentials: {
      httpClient,
      platform
    },
    ...props
  } = _ref;
  const {
    panoramaClient,
    appId,
    tenantType,
    correlationId,
    silentInstall = false,
    avoidPostInstallation = false,
    onInstallationCompleted,
    onInstallationFailed,
    MarketingConsentContent,
    hideModalOverlay,
    version,
    pageId,
    isOneStepInstall
  } = props;
  const [installationId] = useState(() => uuidv4());
  const [tenantId, setTenantId] = useState(initialTenantId || '');
  const {
    prerequisitesState
  } = useRenderControl();
  const appInstallerProps = useMemo(() => ({
    ...props,
    installationId,
    tenantId
  }), [props, installationId, tenantId]);
  useEffect(() => {
    initBiLogger({
      appId,
      tenantId,
      tenantType,
      platform,
      version,
      avoidPostInstallation,
      silentInstall,
      correlationId,
      installationId,
      isMarketingConsent: Boolean(MarketingConsentContent || isOneStepInstall),
      pageId
    });
    reportInstallerInitiated();
  }, []);
  return /*#__PURE__*/React.createElement(WixDesignSystemProvider, {
    features: {
      newColorsBranding: true
    }
  }, /*#__PURE__*/React.createElement(PanoramaContextProvider, {
    panoramaClient: panoramaClient,
    appId: appId,
    tenantId: tenantId,
    installationId: installationId
  }, /*#__PURE__*/React.createElement(ModalsContextProvider, {
    onInstallationCompleted: onInstallationCompleted,
    hideModalOverlay: hideModalOverlay
  }, /*#__PURE__*/React.createElement(ErrorHandlerProvider, {
    silentInstall: silentInstall,
    onInstallationFailed: onInstallationFailed
  }, /*#__PURE__*/React.createElement(InstallerMainContextProvider, _extends({}, props, {
    platform: platform,
    httpClient: httpClient,
    tenantId: tenantId,
    setTenantId: setTenantId
  }), /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: prerequisitesState.isDetermined ? getI18n() : {}
  }, /*#__PURE__*/React.createElement(NewWindowHandlersContextProvider, null, /*#__PURE__*/React.createElement(AppInstallerPropsContext.Provider, {
    value: appInstallerProps
  }, /*#__PURE__*/React.createElement(AppWrapper, null)))))))));
};
//# sourceMappingURL=AppInstallerContent.js.map